import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface TestimonialCardProps {
  quote: string;
  name: string;
  role: string;
  className?: string;
}

const STAR_COUNT = 5;

export function TestimonialCard({
  quote,
  name,
  role,
  className,
}: TestimonialCardProps) {
  return (
    <div
      className={cn(
        "bg-card border border-border rounded-2xl p-6",
        className,
      )}
    >
      {/* Stars */}
      <div className="flex justify-center gap-1 mb-4">
        {Array.from({ length: STAR_COUNT }).map((_, i) => (
          <Star
            key={i}
            className="w-5 h-5 fill-yellow-400 text-yellow-400"
          />
        ))}
      </div>

      {/* Quote */}
      <p className="text-foreground mb-6 leading-relaxed">
        {quote}
      </p>

      {/* Author */}
      <div>
        <p className="text-sm font-semibold text-foreground">{name}</p>
        <p className="text-xs text-muted-foreground">{role}</p>
      </div>
    </div>
  );
}
